"use client";

import { useEffect, useState } from "react";
import { apiCall } from "@/utils/api";
import { routing } from "@/i18n/routing";

export type Pack = {
	name: string;
	amount: number;
	price: number;
	pack_id: number;
};

type Locale = (typeof routing.locales)[number];

export function useBillingPacks(locale: Locale) {
	const [packs, setPacks] = useState<Pack[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		let mounted = true;
		const loadPacks = async () => {
			setIsLoading(true);
			setError(null);
			try {
				const res = await apiCall<{ packs?: Pack[] }>("billing/packs/", undefined, "GET", locale);
				if (!mounted) return;
				setPacks(res.packs || []);
			} catch (err) {
				if (!mounted) return;
				console.error("Failed to load billing packs", err);
				setError("Failed to load billing packs");
			} finally {
				if (mounted) {
					setIsLoading(false);
				}
			}
		};
		void loadPacks();

		return () => {
			mounted = false;
		};
	}, [locale]);

	return { packs, isLoading, error };
}
